import { FallBackImage } from "../default/fallback-image";
import ReactPaginate from 'react-paginate';
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { fetchGetAdsFilters } from "../../../services/api";
import { NumericFormat } from 'react-number-format';
import { Container, Row, Col, Accordion } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import { useForm } from "react-hook-form";

export default function StockInventoryListing({
    ads,
    pageSize,
    models
}) {
    const router = useRouter();
    const pageCount = Math.ceil(ads.paginationOut.totalRows / pageSize);
    const from = !router.query.pag ? 1 : (parseInt(router.query.pag) * parseInt(pageSize)) + 1;
    const to = !router.query.pag ? ads.items.length : (parseInt(router.query.pag) * parseInt(pageSize)) + ads.items.length;
    const [filters, setFilters] = useState({ isLoading: true, brands: [], models: [], yearsModel: [], transmissions: [], fuels: [] });
    const { handleSubmit, register, setValue } = useForm();

    const handlePageClick = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.pag = event.selected;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    };
    const handleFilterCheckboxClick = (event, value, type) => {
        if (event.target.checked) {
            if (router.query[type]) router.query[type] = router.query[type] + `|${value}`;
            else router.query[type] = value;
        }
        else {
            if (router.query[type].indexOf('|') >= 0) {
                const splitStr = router.query[type].split('|');
                router.query[type] = splitStr.filter(item => item !== value).join('|');
            }
            else delete router.query[type];
        }
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleOrderChange = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.ordem = event.target.value;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleGridTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'grid';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleListTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'list';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceFromChange = (event) => {
        if (event.target.value) router.query.preco_de = event.target.value;
        else delete router.query['preco_de'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceToChange = (event) => {
        if (event.target.value) router.query.preco_ate = event.target.value;
        else delete router.query['preco_ate'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleYearFromChange = (event) => {
        if (event.target.value) router.query.ano_de = event.target.value;
        else delete router.query['ano_de'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    };

    const handleYearToChange = (event) => {
        if (event.target.value) router.query.ano_ate = event.target.value;
        else delete router.query['ano_ate'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    };

    const onSubmit = (data) => {
        if (data.txtFilter) {
            router.query.filter = data.txtFilter;
            localStorage.setItem('txtFilter', data.txtFilter);
        } else {
            delete router.query.filter;
            localStorage.removeItem('txtFilter');
        }
        router.push(`/estoque?${new URLSearchParams(router.query)}`);
    }

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const apiYears = filters.yearsModel.map(item => parseInt(item.name)).filter(year => !isNaN(year));
        const minYear = Math.min(...apiYears);
        const maxYear = currentYear + 1;
        const yearRange = [];
        for (let year = maxYear; year >= minYear; year--) {
            yearRange.push(year);
        }
        return yearRange;
    };

    useEffect(() => {
        if (filters.isLoading) {
            fetchGetAdsFilters({
                condition: router.pathname === '/novos'
                    ? 'NEW'
                    : router.pathname === '/seminovos'
                        ? 'USED'
                        : ''
            })
                .then(res => {
                    if (res) { setFilters({ isLoading: false, ...res }); }
                })
                .catch(() => { setFilters({ ...filters, isLoading: false }); });
        }
        else if (!filters.isLoading) $(".at_scrollbar").mCustomScrollbar({ axis: "y" });
    }, [filters, router.pathname]);

    useEffect(() => {
        const savedFilter = localStorage.getItem('txtFilter');
        setValue('txtFilter', savedFilter || '');
    }, [setValue]);

    useEffect(() => {
        $(".ring-preloader").fadeOut();
    }, [ads]);

    return (
        <section className="inventory-details-area ptb-40">
            <Container>
                <Row>
                    <div className="bg-white rounded iv_sidebar_widget mb-lg-4" style={{ padding: '16px' }}>
                        <form className="ct-form-wrapper" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row g-4">
                                <div className="col-lg-9">
                                    <div className="input-field">
                                        <input
                                            type="text"
                                            placeholder="Filtre por marca ou modelo"
                                            {...register("txtFilter")}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 submit-btn align-self-end">
                                    <button
                                        style={{ width: "100%" }}
                                        className="btn btn-secondary btn-md"
                                        type="submit"
                                    >
                                        Buscar Agora
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Col lg={3}>
                        <div className="sidebar-widget">
                            <form>
                                <Accordion defaultActiveKey={[]} flush alwaysOpen>
                                    {/* {
                                        filters.brands.length > 0
                                            ? <Accordion.Item eventKey="0">
                                                <Accordion.Header>Marca</Accordion.Header>
                                                <Accordion.Body>
                                                    <Scrollbars style={{ height: 250 }}>
                                                        {
                                                            filters.brands.map((item, index) =>
                                                                <li key={index}>
                                                                    <label className="label-form">
                                                                        <input style={{ marginRight: "10px" }}
                                                                            className="chck-form"
                                                                            type="checkbox"
                                                                            defaultChecked={router.query.marca ? router.query.marca.split('|').includes(item.name) : false}
                                                                            onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'marca'); }} />
                                                                        {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                    </label>
                                                                </li>)
                                                        }
                                                    </Scrollbars>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            : null
                                    }
                                    {
                                        models.models.length > 0
                                            ? <Accordion.Item eventKey="1">
                                                <Accordion.Header>Modelo</Accordion.Header>
                                                <Accordion.Body>
                                                    <Scrollbars style={{ height: 250 }}>
                                                        {
                                                            models.models.map((item, index) =>
                                                                <li key={index}>
                                                                    <label className="label-form">
                                                                        <input style={{ marginRight: "10px" }}
                                                                            type="checkbox"
                                                                            defaultChecked={router.query.modelo ? router.query.modelo.split('|').includes(item.name) : false}
                                                                            onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'modelo'); }} />
                                                                        {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                    </label>
                                                                </li>)
                                                        }
                                                    </Scrollbars>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            : null
                                    } */}
                                    {
                                        filters.yearsModel.length > 0 &&
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>Ano Modelo</Accordion.Header>
                                            <Accordion.Body>
                                                <p>
                                                    <select onChange={handleYearFromChange}>
                                                        <option value="">Ano de:</option>
                                                        {generateYearOptions().map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </p>
                                                <p>
                                                    <select onChange={handleYearToChange}>
                                                        <option value="">Ano Até:</option>
                                                        {generateYearOptions().map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    }

                                    {
                                        filters.transmissions.length > 0
                                            ? <Accordion.Item eventKey="3">
                                                <Accordion.Header>Câmbio</Accordion.Header>
                                                <Accordion.Body>
                                                    <Scrollbars style={{ height: 250 }}>
                                                        {
                                                            filters.transmissions.map((item, index) =>
                                                                <li key={index}>
                                                                    <label className="label-form">
                                                                        <input
                                                                            style={{ marginRight: "10px" }}
                                                                            type="checkbox"
                                                                            defaultChecked={router.query.cambio ? router.query.cambio.split('|').includes(item.name) : false}
                                                                            onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'cambio'); }} />
                                                                        {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                    </label>
                                                                </li>)
                                                        }
                                                    </Scrollbars>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            : null
                                    }
                                    {
                                        filters.fuels.length > 0
                                            ? <Accordion.Item eventKey="4">
                                                <Accordion.Header>Combustível</Accordion.Header>
                                                <Accordion.Body>
                                                    <Scrollbars style={{ height: 250 }}>
                                                        {
                                                            filters.fuels.map((item, index) =>
                                                                <li key={index}>
                                                                    <label className="label-form">
                                                                        <input
                                                                            style={{ marginRight: "10px" }}
                                                                            type="checkbox"
                                                                            defaultChecked={router.query.combustivel ? router.query.combustivel.split('|').includes(item.name) : false}
                                                                            onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'combustivel'); }} />
                                                                        {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                    </label>
                                                                </li>)
                                                        }
                                                    </Scrollbars>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            : null
                                    }

                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>Preços</Accordion.Header>
                                        <Accordion.Body>
                                            <p>
                                                <select onChange={handlePriceFromChange}>
                                                    <option value=''>Preço De:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </p>
                                            <p>
                                                <select onChange={handlePriceToChange}>
                                                    <option value=''>Preço Até:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </form>
                            {/* {
                                filters.brands.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_1" className="accordion-button bg-transparent text-secondary p-0 pe-1" data-bs-toggle="collapse">Marca</a>
                                                </h6>
                                                <div className="collapse show" id="acc_1">
                                                    <div className="accordion-body ps-0 pb-0 pe-2" id="marcas">
                                                        <ul className="iv2_sidebar_list at_scrollbar" id="mar">
                                                            {
                                                                filters.brands.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.marca ? router.query.marca.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'marca'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                models.models.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_2" className="accordion-button bg-transparent text-secondary p-0 pe-1" data-bs-toggle="collapse">Modelo</a>
                                                </h6>
                                                <div className="collapse show" id="acc_2">
                                                    <div className="accordion-body ps-0 pb-0 pe-2" id="modelos">
                                                        <ul className="iv2_sidebar_list at_scrollbar" id="mod">
                                                            {
                                                                models.models.map((item, index) =>
                                                                    <li key={index} id={`${item.name}`}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.modelo ? router.query.modelo.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'modelo'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.yearsModel.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_3" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Ano Modelo</a>
                                                </h6>
                                                <div className="collapse" id="acc_3">
                                                    <div className="accordion-body ps-0 pb-0 pe-2" id="anomod">
                                                        <ul className="iv2_sidebar_list at_scrollbar" id="anom">
                                                            {
                                                                filters.yearsModel.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input type="checkbox"
                                                                                defaultChecked={router.query.ano ? router.query.ano.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'ano'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.transmissions.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_4" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Câmbio</a>
                                                </h6>
                                                <div className="collapse" id="acc_4">
                                                    <div className="accordion-body ps-0 pb-0 pe-2" id="cambio">
                                                        <ul className="iv2_sidebar_list at_scrollbar" id="camb">
                                                            {
                                                                filters.transmissions.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.cambio ? router.query.cambio.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'cambio'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                filters.fuels.length > 0
                                    ? <div className="iv2_sidebar_widget iv2_checkfilter_widget">
                                        <div className="accordion iv2_sidebar_accordion">
                                            <div className="accordion-item border-0">
                                                <h6 className="accordion-header">
                                                    <a href="#acc_5" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Combustível</a>
                                                </h6>
                                                <div className="collapse" id="acc_5">
                                                    <div className="accordion-body ps-0 pb-0 pe-2" id="combustivel">
                                                        <ul className="iv2_sidebar_list at_scrollbar" id="comb">
                                                            {
                                                                filters.fuels.map((item, index) =>
                                                                    <li key={index}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                defaultChecked={router.query.combustivel ? router.query.combustivel.split('|').includes(item.name) : false}
                                                                                onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'combustivel'); }} />
                                                                            <span className="ct-checkbox me-2">
                                                                                <i className="fa-solid fa-check"></i>
                                                                            </span>
                                                                            {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                                                        </label>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="iv2_sidebar_widget iv2_rangeslider_widget">
                                <div className="accordion iv2_sidebar_accordion">
                                    <div className="accordion-item border-0">
                                        <h6 className="accordion-header ">
                                            <a href="#acc_6" className="accordion-button bg-transparent collapsed text-secondary p-0 pe-1" data-bs-toggle="collapse">Preço</a>
                                        </h6>
                                        <div className="collapse" id="acc_6">
                                            <div className="accordion-body ps-0 pb-0">
                                                <select
                                                    className="form-select fw-500"
                                                    onChange={handlePriceFromChange}>
                                                    <option value=''>Preço De:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </div>
                                            <div className="accordion-body ps-0 pb-0">
                                                <select
                                                    className="form-select fw-500"
                                                    onChange={handlePriceToChange}>
                                                    <option value=''>Preço Até:</option>
                                                    <option value='10000'>R$ 10.000,00</option>
                                                    <option value='20000'>R$ 20.000,00</option>
                                                    <option value='30000'>R$ 30.000,00</option>
                                                    <option value='40000'>R$ 40.000,00</option>
                                                    <option value='50000'>R$ 50.000,00</option>
                                                    <option value='60000'>R$ 60.000,00</option>
                                                    <option value='70000'>R$ 70.000,00</option>
                                                    <option value='80000'>R$ 80.000,00</option>
                                                    <option value='90000'>R$90.000,00</option>
                                                    <option value='100000'>R$ 100.000,00</option>
                                                    <option value='200000'>R$ 200.000,00</option>
                                                    <option value='300000'>R$ 300.000,00</option>
                                                    <option value='400000'>R$ 400.000,00</option>
                                                    <option value='500000'>R$ 500.000,00</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </Col>
                    <div className="col-xl-9">
                        <div className="iv_listing mt-5 mt-xl-0">
                            <div className="iv_listing_top d-flex flex-wrap align-items-center bg-white justify-content-center justify-content-sm-between rounded mb-4">
                                <p className="mb-0 fw-500 d-inline-block">{`Mostrando de ${from} até ${to} de ${ads.paginationOut.totalRows} registros`}</p>
                                <div className="iv_listing_filter_menu d-flex flex-wrap align-items-center justify-content-center">
                                    <p className="mb-0 flex-shrink-0 fw-semibold">Ordenar Por:</p>
                                    <select
                                        className="form-select fw-500"
                                        onChange={handleOrderChange}>
                                        <option value='BRAND_AND_MODEL'>Marca e Modelo</option>
                                        <option value='LOWEST_PRICE'>Menor Preço</option>
                                        <option value='BIGGEST_PRICE'>Maior Preço</option>
                                        <option value='NEWER_VEHICLES'>Mais Novos</option>
                                    </select>
                                    <a href="#" className={`grid_btn ${!router.query.tipo_lista || router.query.tipo_lista === 'grid' ? 'active' : ''}`} onClick={handleGridTypeClick}><i className="flaticon-menu-1"></i></a>
                                    <a href="#" className={`grid_btn ${router.query.tipo_lista && router.query.tipo_lista === 'list' ? 'active' : ''}`} onClick={handleListTypeClick}><i className="flaticon-list-interface-symbol"></i></a>
                                </div>
                            </div>
                             <div className="row g-4 justify-content-center">
                                {
                                    ads.items.length > 0
                                        ? ads.items.map((item, index) =>
                                            !router.query.tipo_lista || router.query.tipo_lista === 'grid'
                                                ? <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6" key={index}>
                                                    <div
                                                        className="filter-card-item position-relative overflow-hidden rounded bg-white"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => { window.location = `anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}` }}
                                                    >
                                                        <div
                                                            className="feature-thumb position-relative overflow-hidden"
                                                            style={{
                                                                position: 'relative',
                                                                width: '100%',
                                                                maxWidth: '430px',
                                                                aspectRatio: '70/55'
                                                            }}>
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <FallBackImage
                                                                    className='img-card-fluid'
                                                                    priority={true}
                                                                    alt={`${item.brand} ${item.model}`}
                                                                    src={item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"} />
                                                            </a>
                                                        </div>
                                                        <div className="filter-card-content">
                                                            <div className="price-btn text-end position-relative">
                                                                {
                                                                    item.promotionalPrice
                                                                        ? <h5 className="price">
                                                                            {
                                                                                item.price ?
                                                                                    <NumericFormat
                                                                                        className="small-btn-meta"
                                                                                        style={{ color: 'white', fontSize: '14px', textDecoration: 'line-through' }}
                                                                                        value={item.price ?? 0}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        prefix='De R$ ' />
                                                                                        : <span className="small-btn-meta">Consulte-nos</span>                                                            
                                                                            }
                                                                        </h5>
                                                                        : null
                                                                }
                                                                <h5 className="price">
                                                                    {
                                                                        item.price ?
                                                                            <NumericFormat
                                                                                className="small-btn-meta"
                                                                                style={{ fontSize: '16px' }}
                                                                                value={item.promotionalPrice ? item.promotionalPrice : item.price}
                                                                                displayType={'text'}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                prefix={`${item.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                                : <span className="small-btn-meta">Consulte-nos</span>                                                            
                                                                    }
                                                                </h5>
                                                            </div>
                                                            <a
                                                                href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}
                                                                className="mt-2 d-block">
                                                                <span className="h5">{`${item.brand} ${item.model}`}</span>
                                                            </a>
                                                            <span
                                                                className="meta-content"
                                                                style={{
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    display: 'inline-block',
                                                                    width: '100%'
                                                                }}>{item.version}</span>
                                                            <hr className="spacer mt-3 mb-3" />
                                                            <div className="card-feature-box d-flex align-items-center">
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.transmission}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                    {item.transmission}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.fuel}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                    {item.fuel}
                                                                </div>
                                                            </div>
                                                            <div className="card-feature-box d-flex align-items-center">
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.transmission}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-calendar"></i></span>
                                                                    {item.yearModel}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.fuel}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="fa fa-gauge"></i></span>
                                                                    <NumericFormat
                                                                        value={item.mileage ?? 0}
                                                                        displayType={'text'}
                                                                        thousandSeparator={'.'}
                                                                        decimalSeparator={','}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div className="col-12" key={index}>
                                                    <div
                                                        className="listing_card_item bg-white rounded overflow-hidden d-flex flex-row align-items-center position-relative"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => { window.location = `anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}` }}>
                                                        <div className="thumb-wrapper rounded-start">
                                                            <div
                                                                className="feature-thumb position-relative overflow-hidden"
                                                                style={{
                                                                    position: 'relative',
                                                                    width: '200px',
                                                                    height: '200px',
                                                                    aspectRatio: '1/1'
                                                                }}>
                                                                <FallBackImage
                                                                    className='img-card-fluid'
                                                                    alt={`${item.brand} ${item.model}`}
                                                                    sizes="30vw"
                                                                    loading="lazy"
                                                                    src={item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex flex-column justify-content-between" style={{ height: '200px', width: '100%' }}>
                                                            <div className="ml-20 mt-2">
                                                                <div className="d-flex flex-row justify-content-between">
                                                                    <div>
                                                                        <h5 className="mb-0">{`${item.brand} ${item.model}`}</h5>
                                                                        <span className="meta-text" style={{ fontSize: '14px' }}><strong className="fw-semibold">{item.version}</strong></span>
                                                                        <div className="card-feature-box d-flex flex-wrap align-items-center mt-20">
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.transmission}>
                                                                                <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                                {item.transmission}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.fuel}>
                                                                                <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                                {item.fuel}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.yearModel}>
                                                                                <span className="me-2"><i className="flaticon-calendar"></i></span>
                                                                                {item.yearModel}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.mileage}>
                                                                                <span className="me-2"><i className="fa fa-gauge"></i></span>
                                                                                <NumericFormat
                                                                                    value={item.mileage ?? 0}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator={'.'}
                                                                                    decimalSeparator={','}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mr-20 d-flex flex-column align-items-end mt-1">
                                                                        {
                                                                            item.promotionalPrice
                                                                                ? <h5>
                                                                                    {
                                                                                        item.price ?
                                                                                            <NumericFormat
                                                                                                className="small-btn-meta"
                                                                                                style={{ color: 'white', fontSize: '12px', textDecoration: 'line-through' }}
                                                                                                value={item.price ?? 0}
                                                                                                displayType={'text'}
                                                                                                thousandSeparator="."
                                                                                                decimalSeparator=","
                                                                                                decimalScale={2}
                                                                                                fixedDecimalScale={true}
                                                                                                prefix='De R$ ' />
                                                                                            : <span className="small-btn-meta">Consulte-nos</span>
                                                                                    }
                                                                                </h5>
                                                                                : null
                                                                        }
                                                                        <h5>
                                                                            {
                                                                                item.price ?
                                                                                    <NumericFormat
                                                                                        className="small-btn-meta"
                                                                                        style={{ fontSize: '12px' }}
                                                                                        value={item.promotionalPrice ? item.promotionalPrice : item.price}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        prefix={`${item.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                                    : <span className="small-btn-meta">Consulte-nos</span>
                                                                            }
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        )
                                        : <div style={{ textAlign: 'center' }}>
                                            <p>nenhum registro encontrado...</p>
                                        </div>
                                }
                            </div>
                            <div className="template-pagination mt-5 pg-style-2">
                                <ReactPaginate
                                    forcePage={router.query.pag ? parseInt(router.query.pag) : 0}
                                    className="d-flex align-items-center justify-content-center"
                                    activeLinkClassName="active"
                                    breakLabel="..."
                                    nextLabel={<i className="fa-solid fa-angles-right"></i>}
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    previousLabel={<i className="fa-solid fa-angles-left"></i>}
                                    renderOnZeroPageCount={null} />
                            </div>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>
    );
}